export * from '@primeuix/themes/lara/tabmenu';
export { default } from '@primeuix/themes/lara/tabmenu';
